// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"zaa-z","colorTextValue":"Aaa-z","swatches":"Baa-z","collapseLink":"Caa-z","isCollapsed":"Daa-z","dropdown":"Eaa-z","disabled":"Faa-z"};